import {DomainObject} from 'shared/store';
import {observable, action, computed} from 'mobx';
import {Employee} from 'main/stores/employees';
import {User} from 'main/stores/users';
import Expense from './Expense';
import {dateFormatter} from 'shared/tools';
import {formatCurrency} from 'shared/core';

class ExpenseRequest extends DomainObject {
  @observable id;
  @observable title;
  @observable description;
  @observable status;
  @observable amount;
  @observable createdAt;
  @observable actionedAt;
  @observable actionedNotes;
  @observable employee;
  @observable actionedByUser;
  @observable expenses = [];

  @action merge(other) {
    super.merge(other, {
      employee: Employee,
      actionedByUser: User,
      expenses: [Expense],
      _dates: ['createdAt', 'actionedAt']
    });
  }

  @computed get createdAtView() {
    return dateFormatter(this.createdAt);
  }

  @computed get actionedAtView() {
    return dateFormatter(this.actionedAt);
  }

  @computed get amountView() {
    return formatCurrency('CAD', this.amount);
  }

  @computed get canAction() {
    return this.hasLink('approve') && this.hasLink('reject');
  }
}

export default ExpenseRequest;
